// Accent palette echoing the Upgrade Mate PDF section colors
export const ACCENTS = {
  fitness: "#FFC400",   // yellow (Training)
  lifestyle: "#00C2FF", // cyan (Recovery)
  dating: "#FF3DA5",    // magenta (Taking Action)
  money: "#35D24B",     // green (Nutrition)
  bundle: "#0a0a0a",
};

export const accentFor = (key) => ACCENTS[(key || "").toLowerCase()] || "#0a0a0a";
